import type { ReceiptTemplate } from '../schema';

export const fetchRewardsTemplate: ReceiptTemplate = {
  id: 'fetch-rewards',
  name: 'Fetch Rewards Receipt',
  brand: 'FETCH REWARDS',
  description: 'Fetch Rewards points receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: 'none',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'fr-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'FETCH REWARDS',
        businessNameFontSize: 16,
        addressLines: ['POINTS EARNED'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'fr-scan',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'scan', label: 'Scan ID:', value: 'FR-847291034' },
          { id: 'user', label: 'User:', value: 'john@email.com' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'store', label: 'Store:', value: 'WALMART' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'fr-points',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'base', label: 'BASE POINTS', value: '25', isBold: false, isLarge: false },
          { id: 'bonus', label: 'BONUS POINTS', value: '150', isBold: false, isLarge: false },
          { id: 'special', label: 'SPECIAL OFFER', value: '500', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL EARNED', value: '675 pts', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'fr-balance',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'NEW BALANCE: 12,450 pts\n\nKEEP SCANNING!', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

